import { useTheme } from '@mui/styles';
import { useMemo } from 'react';

import { ApplicationMuiTheme } from 'Lib/themes/muiTheme';

type ClientLogoUrls = ApplicationMuiTheme['app']['clientTheme']['logoUrls'];

const emptyClientLogoUrls: ClientLogoUrls = {
    LogoLockupTrueColorsUrl: '',
    logoLockUpUrl: '',
    logoCompanyUrl: '',
    ApplicationLogoUrl: '',
    ClientColorLogoUrl: '',
    ClientInvertedColorLogoUrl: '',
    TassatPayColorCopyrightLogoUrl: '',
    TassatPayColorIconCopyrightLogoUrl: '',
    TheNetworkColorLogoUrl: '',
    logoMemberFdicUrl: '',
    logoEqHousLendUrl: ''
};

export const useClientLogos = (): ClientLogoUrls => {
    const muiTheme = useTheme<ApplicationMuiTheme>();

    const clientLogoUrls = useMemo(() => {
        if (!muiTheme.app) return emptyClientLogoUrls;

        const urls: ClientLogoUrls = muiTheme.app.clientTheme.logoUrls;

        return urls;
    }, [muiTheme]);

    return clientLogoUrls;
};